<template>
  <div>
    <div class="message-content">
      <div class="notification">
        <h4>{{ message }}</h4>
      </div>
    </div>
    <form v-show="false" ref="form" method="post" action="https://www.servipag.com/BotonPago/BotonPago/Pagar">
      <input id="xml" :value="xml" name="xml" type="text">
    </form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      xml: '',
      message: 'Serás redirigido al sitio del proveedor de pagos'
    };
  },
  watch: {
    xml() {
      this.$nextTick(() => {
        this.$refs.form.submit();
      });
    }
  },
  async mounted() {
    this.xml = this.$store.state.paymentsModule.xml1;
  }
};
</script>
<style scoped>
  .message-content {
    width: 95%;
    margin: 30px auto;
  }
  .message-content .message {
    background: transparent;
    text-align: center;
  }
</style>
